module.exports = __webpack_public_path__ + "img/silver.a5f32949.webp";